import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import {FormBuilder, FormGroup, Validators, ValidationErrors, ValidatorFn, AbstractControl, Form} from '@angular/forms';
import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../services/user.service';
import { Subject } from 'rxjs';
import {finalize, takeUntil} from 'rxjs/operators';
import Swal from 'sweetalert2/dist/sweetalert2.js';

import { locale as english } from '../i18n/en';
import { locale as romania } from '../i18n/ro';
import {AuthRequestModel} from '../models/auth.model';
import {
    CompanyRequestModel,
    FinishRequestModel,
    RegisterRequestModel,
    UserRegistrationModel
} from '../models/register.model';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {ValidationMessageService} from '../../shared/services/validation-message-handle';
import {MatFileUploadComponent} from '@webacad/ng-mat-file-upload';
import {AuthRegisterModel} from '../models/auth-register.model';
import {BaseModel} from '../../shared/entities/base.model';
import {UserModel} from '../models/user.model';
import {HttpApiService} from '../../shared/services/http-api.service';


@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})

export class RegisterComponent implements OnInit {

    public loading = false;

    public registerForm: FormGroup;
    public companyForm: FormGroup;
    public finishForm: FormGroup;
    public entityTypeValue =  'student';
    private _unsubscribeAll: Subject<any>;
    public selectedImages: any = null;

    public userModel: UserModel = null;
    private selectedFile: any = null;

    constructor(
       private _fuseTranslationLoaderService: FuseTranslationLoaderService,
       private _fuseConfigService: FuseConfigService,
       private _formBuilder: FormBuilder,
       private userService: UserService,
       private validationMessageService: ValidationMessageService,
       private route: ActivatedRoute,
       private router: Router,
       private httpApiService: HttpApiService,
    ) {
        this._fuseTranslationLoaderService.loadTranslations(english, romania);

        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar   : {
                    hidden: true
                },
                toolbar  : {
                    hidden: true
                },
                footer   : {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }

    ngOnInit(): void
    {

        this.registerForm = this._formBuilder.group({
            name           : ['', Validators.required],
            email          : ['', [Validators.required, Validators.email]],
            password       : ['', Validators.required],
            password_confirmation: ['', [Validators.required, confirmPasswordValidator]],
        });

        this.companyForm = this._formBuilder.group({
            name           : ['', Validators.required],
            uniqueRegistrationCode : ['', [Validators.required]],
            nrRegCom       : ['', Validators.required],
        });

        this.finishForm = this._formBuilder.group({
            terms  : ['', Validators.required],
            file   : ['', Validators.required],
        });


        // Update the validity of the 'password_confirmation' field
        // when the 'password' field changes
        this.registerForm.get('password').valueChanges
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                this.registerForm.get('password_confirmation').updateValueAndValidity();
            });
    }

    goToLogin(): void
    {
        this.router.navigateByUrl('/auth/login');
    }

    openTermsAndConditions(): void
    {
        console.log('Not implemented yet');
    }

    public onFileChange(files: MatFileUploadComponent): void {
        this.selectedFile = files;
    }

    public sendImage(): void {

        const documentType = (this.entityTypeValue === 'student') ? 'cv' : 'delegation';

        this.loading = true;
        this.httpApiService.postFile(this.selectedFile.value[0], 'User', documentType, this.userModel.uid)
            .pipe(finalize(() => this.loading = false))
            .subscribe(() => {
                this.router.navigateByUrl('/auth/login');
            });

    }

    public onFinishRegistration(): void {

        this.loading = true;

        const data: RegisterRequestModel = new RegisterRequestModel();

        data.user = new UserRegistrationModel().map(this.registerForm.getRawValue());
        data.user.entityType = this.entityTypeValue;

        data.company = new CompanyRequestModel().map(this.companyForm.getRawValue());

        data.finish = new FinishRequestModel().map(this.finishForm.getRawValue());

        if(this.selectedImages) {
            data.finish.files   = new FormData();
            data.finish.files.append('file', this.selectedImages, this.selectedImages.name);
        }

        // TODO Find solution to send file in same request

        this.userService.register(data)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response) => {
                if (response.status === true) {

                    this.userModel = new UserModel().map(response.payload);
                    this.sendImage();

                    Swal.fire({
                        title: 'Inregistrare',
                        html: 'Contul tau a fost inregistrat cu succes! <br> vei fi redirectionat in cateva momente catre pagina de autentificare. ',
                        icon: 'success',
                        footer: 'Va multumim ca ati ales serviciile noastre!',
                    });

                }
            }, err => {


                if (err instanceof HttpErrorResponse) {
                    this.validationMessageService.serverSideValidation(err, this.registerForm, 'user,' ,false);
                    this.validationMessageService.serverSideValidation(err, this.companyForm, 'company.',  false);
                    this.validationMessageService.serverSideValidation(err, this.finishForm,  'finish.', false);
                }else{

                }
            });

    }
}

export const confirmPasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    if ( !control.parent || !control )
    {
        return null;
    }

    const password = control.parent.get('password');
    const password_confirmation = control.parent.get('password_confirmation');

    if ( !password || !password_confirmation )
    {
        return null;
    }

    if ( password_confirmation.value === '' )
    {
        return null;
    }

    if ( password.value === password_confirmation.value )
    {
        return null;
    }

    return {passwordsNotMatching: true};
};

